import { render, staticRenderFns } from "./LibraryResourceVideo.vue?vue&type=template&id=f6f2cb24&"
import script from "./LibraryResourceVideo.vue?vue&type=script&lang=js&"
export * from "./LibraryResourceVideo.vue?vue&type=script&lang=js&"
import style0 from "./LibraryResourceVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports